import { render, staticRenderFns } from "./kpsrPlan.vue?vue&type=template&id=22f5f83d"
import script from "./kpsrPlan.vue?vue&type=script&lang=js"
export * from "./kpsrPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f5f83d')) {
      api.createRecord('22f5f83d', component.options)
    } else {
      api.reload('22f5f83d', component.options)
    }
    module.hot.accept("./kpsrPlan.vue?vue&type=template&id=22f5f83d", function () {
      api.rerender('22f5f83d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/plan/kpsrPlan.vue"
export default component.exports